<template>
    <div v-if="show" class="w-full bg-red-600 text-white px-4 py-2 flex items-center justify-between gap-4 text-sm">
        <div class="flex items-center gap-2 min-w-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4a2 2 0 00-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z" />
            </svg>
            <span class="min-w-0 truncate">
                <strong>Pagamento recusado.</strong> Atualize seu cartão para evitar o cancelamento.
            </span>
        </div>
        <div class="flex items-center gap-2 shrink-0">
            <router-link :to="{ name: 'account' }" @click="dismiss" class="text-xs font-semibold bg-white text-red-600 rounded px-2 py-1 hover:bg-red-50 transition">
                Resolver agora
            </router-link>
            <button @click="dismiss" aria-label="Fechar" class="text-white/80 hover:text-white">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';
import AuthService from '@/services/AuthService';
import LocalStorage from '@/services/LocalStorageService';

const LS_KEY = 'payment_failed_banner_dismissed_at';
const DISMISS_MINUTES = 60;

export default {
    setup() {
        const show = ref(false);
        const route = useRoute();
        let isPastDue = false;

        function shouldShow() {
            if (!isPastDue) return false;
            const lastDismissed = LocalStorage.get(LS_KEY);
            if (!lastDismissed) return true;
            try {
                const diff = (Date.now() - new Date(JSON.parse(lastDismissed)).getTime()) / 60000;
                return diff > DISMISS_MINUTES;
            } catch {
                return true;
            }
        }

        function dismiss() {
            LocalStorage.set(LS_KEY, JSON.stringify(new Date().toISOString()));
            show.value = false;
        }

        function checkAuth() {
            const auth = AuthService.getAuthInfo() || {};
            isPastDue = auth.subscription_status === 'past_due';
            show.value = shouldShow();
        }

        onMounted(checkAuth);
        const stopWatch = watch(() => route.fullPath, () => { if (isPastDue) show.value = shouldShow(); });
        onBeforeUnmount(() => stopWatch());

        return { show, dismiss };
    }
};
</script>
